const COMMODITIES = [
  'Beverages - Alcohol',
  'Beverages - Non-Alcohol',
  'Food - Dry',
  'Food - Refrigerated',
  'Food - Produce/Perishables',
  'Goods - Antiques, Artwork',
  'Goods - Electronics',
  'Goods - Furs, Leather',
  'Goods - Non-Ferrous Metals',
  'Goods - Live Animals',
  'Goods - Jewelry, Minerals, Precious Metals',
  'Tobacco',
  'Pharmaceuticals',
  'Paper Products',
  'General Merchandise (FAK)',
  'Hazardous Materials',
]

export function getCommodityOptions(platform) {
  const filtered =
    platform === 'dn'
      ? COMMODITIES.filter((c) => c !== 'Hazardous Materials')
      : COMMODITIES

  return filtered.map((c) => ({ key: c, value: c, text: c }))
}
